'use client';

import { ReactNode } from 'react';
import './styles/default.scss';
import { getAppPlatform } from '@/logic/platform';
import { APP_PLATFORM } from '@/utils/constants';

export type NotificationBoxProps = {
    title: ReactNode;
    children: ReactNode;
    buttonText: ReactNode;
    onButtonClick: () => void;
    linkText: ReactNode;
    linkHref: string;
};

export const NotificationBox: React.FC<NotificationBoxProps> = ({
    title,
    children,
    buttonText,
    onButtonClick,
    linkText,
    linkHref
}) => {
    const handleLinkClick = async (event: React.MouseEvent<HTMLAnchorElement>) => {
        const platform = getAppPlatform();

        if (platform === APP_PLATFORM.Web) {
            event.preventDefault();
            const { ResponsibleGaming } = await import('@fanduel/cpe-um-bundle/responsible-gaming/library');
            await ResponsibleGaming.presentRealityCheckSettingsAsync(undefined, true, true);
        } else if (platform === APP_PLATFORM.Android) {
            // TODO: Implement Android bridge here and delete the link when it is ready
        }
    };

    return (
        <div id="realityCheck" className="games-modal">
            <div className="games-container">
                <div className="header">
                    <div className="title">{title}</div>
                </div>
                <div className="body">{children}</div>
                <div className="footer">
                    <button className="button cta-button" onClick={onButtonClick}>
                        {buttonText}
                    </button>
                    <a
                        className="link-button"
                        href={linkHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleLinkClick}>
                        {linkText}
                    </a>
                </div>
            </div>
        </div>
    );
};
